import { Component, computed, inject, input } from '@angular/core';
import { IconSize, KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { IconName, IconService } from '@unity/services/icon.service';

@Component({
  selector: 'unity-icon-shared',
  standalone: true,
  imports: [KENDO_SVGICON],
  templateUrl: './icon-shared.component.html',
  styleUrl: './icon-shared.component.scss',
})
export class IconSharedComponent {
  public readonly $icon = input.required<IconName>({ alias: 'icon' });
  public readonly $size = input<IconSize>(undefined, { alias: 'size' });

  private readonly iconService = inject(IconService);

  protected readonly $svgIcon = computed(() => {
    return this.iconService.getSVGIcon(this.$icon());
  });
}
